<app-capture-history-item-title>
  NuvemRx Advanced Referral Portal Historical Verification
</app-capture-history-item-title>

<app-capture-history-item-body>
  <small>
    Claim ARP ID: {{ captureHistoryItem.data.claimArpId }}<br />
    Claim ARP Status: {{ captureHistoryItem.data.claimArpStatus }}<br />
    External ID: {{ captureHistoryItem.data.externalId }}<br />
    Patient ARP ID: {{ captureHistoryItem.data.patientArpId }}<br />
    Patient ID: {{ captureHistoryItem.data.patientId }}<br />
    Patient Encounter Dates:
    @for (date of captureHistoryItem.data.patientEncounterDates; track date; let last = $last) {
      {{ date | date: 'MM/dd/yyyy' }}{{ last ? '' : ', ' }}
    }
    <br />
    Provider Specialty: {{ captureHistoryItem.data.providerSpecialty }}<br />
  </small>
</app-capture-history-item-body>
